<template>
  <v-dialog
    v-model="show"
    max-width="800"
    persistent
  >
    <v-card flat>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="close"
          icon
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <div class="participants-header mb-0">
          Pontuados: {{ participants.length }} de {{ totalCount }} participantes
        </div>
        <AppTable
          :headers="headers"
          :items="participants"
          :loading="loading"
          hide-title
        />
        <AppPagination
          :length="pageCount"
          :current-pagination="currentPage"
          :loading="loading"
          @onPagination="onPagination"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AppTable from '@/components/ui/AppTable'
import AppPagination from '@/components/ui/AppPagination'
import { getScoredParticipantsByCompany } from '@/services/containers/partners/campaigns'

const mapParticipant = (item) => ({
  name: item.name,
  grossTotal: item.totalSeedz ?? 0,
  difference: item.totalSeedzDifference ?? 0,
  paidTotal: item.totalSeedzWithDeduction ?? 0
})

export default {
  name: 'TotalParticipantsModal',
  components: {
    AppTable,
    AppPagination
  },
  data: () => ({
    show: false,
    title: '',
    campaignId: null,
    partnerId: null,
    participants: [],
    totalCount: 0,
    pageCount: 1,
    currentPage: 1,
    loading: false
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Nome',
          value: 'name',
          sortable: false,
          formatter: ({ name }) => name,
          asTitle: true
        },
        {
          text: 'Total (Bruto)',
          value: 'grossTotal',
          sortable: false,
          formatter: ({ grossTotal }) => this.$currencyFormat(grossTotal || 0)
        },
        {
          text: 'Diferença',
          value: 'difference',
          sortable: false,
          formatter: ({ difference }) => this.$currencyFormat(difference || 0)
        },
        {
          text: 'Total (Pago)',
          value: 'paidTotal',
          sortable: false,
          formatter: ({ paidTotal }) => this.$currencyFormat(paidTotal || 0)
        }
      ]
    }
  },
  methods: {
    open({ campaignId, partnerId, companyName }) {
      this.campaignId = campaignId
      this.partnerId = partnerId
      this.title = `Total de participantes pontuados - ${companyName}`
      this.currentPage = 1
      this.show = true
      this.fetchParticipants()
    },
    close() {
      this.show = false
      this.participants = []
      this.title = ''
      this.totalCount = 0
      this.pageCount = 1
      this.currentPage = 1
      this.campaignId = null
      this.partnerId = null
    },
    async fetchParticipants() {
      if (!this.campaignId || !this.partnerId) return

      this.loading = true
      try {
        const { data } = await getScoredParticipantsByCompany(
          this.campaignId,
          this.partnerId,
          this.currentPage
        )
        const { data: participants, totalCount, pageCount } = data
        this.participants = participants.map(mapParticipant)
        this.totalCount = totalCount
        this.pageCount = pageCount ?? 1
      } catch (err) {
        this.$toast(err.response?.data?.message ?? 'Erro ao carregar participantes', 'red')
      } finally {
        this.loading = false
      }
    },
    onPagination(page) {
      this.currentPage = page
      this.fetchParticipants()
    }
  }
}
</script>

<style lang="stylus" scoped>
.participants-header {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: #001648;
  background-color: #DEE7E6;
  padding: 8px 16px;
  border-radius: 4px 4px 0 0;
  margin-bottom: 0;
}
</style>

